import axios, { AxiosError, AxiosResponse } from 'axios'
import {
    MInspection,
    MInspectionDetail,
    MInspector,
} from '@Models/client/inspection.model'
import { ICommonQuery } from '@Models/common.model'
import * as Redux from 'redux'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'

const INSPECTOR = '/inspectors'
const INSPECTION_SCHEDULE = '/inspections'

const setInspectorLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.SET_INSPECTOR_LOADING,
            payload,
        })
    }
}

const getInspectors = () => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        APIServices.axiosConfig()
        const params = getState()?.client?.inspections?.inspectorQueries
        dispatch(setInspectorLoading(true) as any)
        axios
            .get(INSPECTOR, { params })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const formattedData = data?.map(
                    (item: MInspector) => new MInspector(item)
                )
                const payload = {
                    inspectors: formattedData,
                    inspectorsMetadata: metadata,
                }
                dispatch({ type: ClientActionTypes.GET_INSPECTORS, payload })
                dispatch(setInspectorLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                dispatch(setInspectorLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const setInspectorQueries = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const currentQueries = getState()?.client?.inspections?.inspectorQueries
        const payload = { ...currentQueries, ...params }
        dispatch({ type: ClientActionTypes.SET_INSPECTOR_QUERIES, payload })
    }
}

const createInspection = (body: any) => {
    return () => {
        return new Promise((resolve, reject) => {
            axios
                .post(INSPECTION_SCHEDULE, body)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Inspection created')
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

// inspection schedules

const setInspectionLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.SET_INSPECTOR_LOADING,
            payload,
        })
    }
}

const getInspectionSchedules = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(setInspectionLoading(true) as any)
        axios
            .get(INSPECTION_SCHEDULE, { params })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const formattedData = data?.map(
                    (item: MInspection) => new MInspection(item)
                )
                const payload = {
                    inspections: formattedData,
                    inspectionMetadata: metadata,
                }
                dispatch({
                    type: ClientActionTypes.GET_INSPECTION_SCHEDULES,
                    payload,
                })
                dispatch(setInspectionLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                dispatch(setInspectionLoading(false) as any)
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const setInspectionDetailLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.SET_INSPECTION_SCHEDULE_LOADING,
            payload,
        })
    }
}

const getInspectionAnswer = (inspectionScheduleId: string) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(setInspectionDetailLoading(true) as any)
        axios
            .get(`${INSPECTION_SCHEDULE}/${inspectionScheduleId}`)
            .then((response: AxiosResponse) => {
                const payload = new MInspectionDetail(response?.data)
                dispatch({
                    type: ClientActionTypes.GET_INSPECTION_SCHEDULE,
                    payload,
                })
                dispatch(setInspectionDetailLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(setInspectionDetailLoading(false) as any)
            })
    }
}

const ClientInspectionActions = {
    getInspectors,
    setInspectorQueries,
    createInspection,
    getInspectionSchedules,
    getInspectionAnswer,
}

export default ClientInspectionActions
